/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // reset container
    document.querySelector("#miniCartBody").innerHTML = "";

    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // GA4 view_cart
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: "view_cart",
        ecommerce: {
            currency: Shopify.currency.active,
            value: cart.total_price / 100,
            items: cart.items.map(function (item) {
                return {
                    item_id: item.product_id,
                    item_name: item.product_title,
                    item_variant: item.variant_title,
                    item_category: item.type,
                    price: item.price / 100,
                    quantity: item.quantity,
                    subscription_item: item.selling_plan_allocation !== undefined
                }
            }),
            subscription_included: cart.items.filter(item => item.selling_plan_allocation).length > 0,
        }
    });

    // update active body
    if (cart.item_count === 0) {
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
    } else {
        document.querySelector("#miniCartBody").classList.add("active");
        document.querySelector("#miniCartEmpty").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.add("active");

        // update subtotal
        document.querySelector("#miniCartFooterSubtotal span:last-child").textContent = price(cart.items_subtotal_price);
    }

    // append cart
    cart.items.forEach(function (item) {

        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartBodyItemTitle">${item.product_title}</div>
                    <div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityMinus">-</button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus">+</button>
                    </div>
                </div>
                <div>
                    <button class="miniCartBodyItemRemove">
                        <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z"></path></svg> 
                    </button>
                    <div class="miniCartBodyItemPrice">${price(item.final_line_price)} <s>${item.original_line_price > item.final_line_price ? price(item.original_line_price) : ""}</s></div>
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity == 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }
    });

    document.querySelector("#miniCart").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // GA4 begin_checkout
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
            currency: Shopify.currency.active,
            value: cart.total_price / 100,
            items: cart.items.map(function (item) {
                return {
                    item_id: item.product_id,
                    item_name: item.product_title,
                    item_category: item.type,
                    item_variant: item.variant_title,
                    price: item.price / 100,
                    quantity: item.quantity,
                    subscription_item: item.selling_plan_allocation !== undefined
                }
            }),
            subscription_included: cart.items.filter(item => item.selling_plan_allocation).length > 0,
        }
    });

    this.classList.remove("loading");

    window.location.href = "/checkout";
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));
